import initFlatCard from '@/components/flat-card/flat-card';
import {Navigation} from 'swiper/modules';
import Swiper from 'swiper';

const initFlatSlider = (parent: HTMLElement): void => {
    if (!parent) {
        console.warn(`Parent is ${parent}`);

        return;
    }

    const swiperEl = parent.querySelector('.flat-slider__swiper');
    const nextEl = parent.querySelector('.flat-slider__arrows .slider__arrow-next') as HTMLElement;
    const prevEl = parent.querySelector('.flat-slider__arrows .slider__arrow-prev') as HTMLElement;
    const cardsEl = [].slice.call(parent.querySelectorAll('.flat-slider__flat-card')) as HTMLElement[];

    if (swiperEl) {
        // eslint-disable-next-line no-new
        new Swiper(swiperEl as HTMLElement, {
            modules      : [Navigation],
            loop         : true,
            slidesPerView: 1,
            spaceBetween : 16,
            navigation   : {
                nextEl,
                prevEl
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween : 20
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween : 30
                }
            }
        });
    }

    if (cardsEl.length) {
        cardsEl.forEach((node) => {
            initFlatCard(node);
        });
    }
};

export default initFlatSlider;
